import apiClient from '../../../services/apiClient';
import { showErrorToast } from '../../../utils/toastHelper';
// const getApiClient= async (method,route)=>{
//     try {
//         const response = await apiClient.get(route);
//         console.log('data',response)
//         return response.data;
//       } catch (error) {

//         console.log('error', error)
//         showErrorToast(
//           error?.message || "An unexpected error occurred."
//         );
//         return error;

//       }
// }
const ApiClient = async (method, route, data = {}) => {
  try {
    let response;
    if (method === 'post') {
      response = await apiClient.post(route, data);
    } else if (method === 'get') {
      response = await apiClient.get(route, { params: data });
    } else if (method === 'put') {
      response = await apiClient.put(route, data);
    }
    console.log('data', response);
    return response.data;
  } catch (error) {
    console.log('error', error);
    showErrorToast(error?.message || 'An unexpected error occurred.');
    return error;
  }
};
export const getPermissionsTypes = async () => {
  return await ApiClient('get', '/permissions-types');
};
export const getUsersWithPermissions = async (query) => {
  return await ApiClient('get', '/users', query);
};
export const registerUser = async (data) => {
  return await ApiClient('post', '/auth/register', data);
};
export const updatePermissions = async (data) => {
  return await ApiClient('put', '/permissions', data);
};
